import { v4 as uuid } from 'uuid';
import { HelpCircle, Book, LifeBuoy } from 'react-feather';

export const HelpCenterFeaturesData = [
	{
		id: uuid(),
		icon: <HelpCircle size="40" strokeWidth="1.5" className="text-primary" />,
		title: 'Meist gestellte Fragen (FAQ)',
		link: '/marketing/help-center/faq/',
		description:
			'FAQ, kurz für Frequently Asked Questions, ist eine Liste häufig gestellter Fragen und Antworten zu einem bestimmten Thema',
		linkname: 'FAQs lesen'
	},
	{
		id: uuid(),
		icon: <Book size="40" strokeWidth="1.5" className="text-primary" />,
		title: 'Guides & Resources',
		link: '/marketing/help-center/guide/',
		description:
			'Unterhalb Guides & Ressources findest du alle Anleitungen und Handbücher, die du für unsere App benötigst. ',
		linkname: 'Guides durchsuchen'
	},
	{
		id: uuid(),
		icon: <LifeBuoy size="40" strokeWidth="1.5" className="text-primary" />,
		title: 'Service Ticket',
		link: '/marketing/help-center/support/',
		description:
			'Deine Frage oder Problem kann nicht gelöst werden? Kontaktieren unseren HelpDesk für eine Unterstützung.',
		linkname: 'Service Ticket erstellen'
	}
];

export default HelpCenterFeaturesData;
